import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8907a1a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "navbar is-fixed-top meb-nav-bkg",
  role: "navigation",
  "aria-label": "main navigation ml-4 mr-4"
}
const _hoisted_2 = { class: "navbar-brand mr-5 ml-5" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_8 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "navbar-start" }
const _hoisted_10 = { class: "navbar-end" }
const _hoisted_11 = { class: "navbar-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-3 mb-3" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-3 mb-3" }, null, -1))
const _hoisted_14 = { class: "buttons is-justify-content-center" }
const _hoisted_15 = { class: "button is-info" }
const _hoisted_16 = { class: "button is-primary" }

import { ref } from "vue";

import LanguageComponent from "./LanguageComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  emits: ["scrollToSection"],
  setup(__props, { emit: __emit }) {

const showNav = ref(false);

 const emit = __emit
 function scrollToSection (section:number) {
   emit('scrollToSection', section)
 }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require(`@/assets/images/azienda/logo-meb.png`)
      }, null, 8, _hoisted_3),
      _createElementVNode("a", {
        role: "button",
        class: _normalizeClass(["navbar-burger", { 'is-active': showNav.value }]),
        "aria-label": "menu",
        "aria-expanded": "false",
        "data-target": "navbarBasicExample",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showNav.value = !showNav.value))
      }, _hoisted_8, 2)
    ]),
    _createElementVNode("div", {
      id: "navbarBasicExample",
      class: _normalizeClass(["navbar-menu meb-nav-bkg", { 'is-active': showNav.value }])
    }, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          class: "navbar-item meb-menu-txt",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (scrollToSection(1)))
        }, _toDisplayString(_ctx.$t('NAV_TARGET')), 1),
        _createElementVNode("a", {
          class: "navbar-item meb-menu-txt",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollToSection(2)))
        }, _toDisplayString(_ctx.$t('NAV_DOES IT WORK')), 1),
        _createElementVNode("a", {
          class: "navbar-item meb-menu-txt",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollToSection(3)))
        }, _toDisplayString(_ctx.$t('NAV_SERVICES')), 1),
        _createElementVNode("a", {
          class: "navbar-item meb-menu-txt",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (scrollToSection(4)))
        }, _toDisplayString(_ctx.$t('NAV_CONTACTS')), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(LanguageComponent),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t('NAV_SIGN')), 1),
            _createElementVNode("a", _hoisted_16, _toDisplayString(_ctx.$t('NAV_LOG')), 1)
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})